import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtm } from "@/lib/leads";
import { trackPage } from "@/lib/behavior";
import { trackPageView } from "@/lib/analytics";

/** Captures UTM data and shows the welcome lead form on every public page. */
const GlobalWelcomeLead = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    captureUtm();
  }, [pathname, search]);

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  useEffect(() => trackPage(pathname), [pathname]);

  return null;
};

export default GlobalWelcomeLead;
